/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosAssistantPlanningSuggestionsDto,
  GetApiV1PlanningSuggestionsParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getPlanningSuggestions = () => {
/**
 * @summary The day of all plannable employees, the tasks open on date and every
employee × task pair that fits, best score first. employeeId or
taskId narrow the evaluations; employees and tasks stay complete.
date is required: missing or unparsable → 400 `validation.failed`.
 */
const getApiV1PlanningSuggestions = (
    params: GetApiV1PlanningSuggestionsParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAssistantPlanningSuggestionsDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAssistantPlanningSuggestionsDto>(
      {url: `/api/v1/planning/suggestions`, method: 'GET',
        params
    },
      options);
    }
  return {getApiV1PlanningSuggestions}};
export type GetApiV1PlanningSuggestionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningSuggestions>['getApiV1PlanningSuggestions']>>>
